import DatePicker from "react-datepicker";
import { useState, useEffect } from "react";
import { SPACING } from "../../constants/design/spacing";

interface IDatetimePickerProps {
  onDateChange: (startTimestamp: number, endTimestamp: number) => void;
  overridePlaceholder?: string;
  initialDateRange?: [Date | null, Date | null];
}

function DatetimePicker({ onDateChange, overridePlaceholder, initialDateRange }: IDatetimePickerProps) {
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>(initialDateRange || [null, null]);

  // Initialize with the default date range if provided
  useEffect(() => {
    if (initialDateRange && initialDateRange[0] && initialDateRange[1]) {
      const startUnixTimestamp = Math.floor(initialDateRange[0].getTime() / 1000);
      const endUnixTimestamp = Math.floor(initialDateRange[1].getTime() / 1000);
      onDateChange(startUnixTimestamp, endUnixTimestamp);
    }
  }, []); // Empty dependency array so it only runs once on mount

  const handleDateChange = (update: [Date | null, Date | null]) => {
    setDateRange(update);
    const [startDate, endDate] = update;
    if (startDate && endDate) {
      const startUnixTimestamp = Math.floor(startDate.getTime() / 1000);
      const endUnixTimestamp = Math.floor(endDate.getTime() / 1000);
      onDateChange(startUnixTimestamp, endUnixTimestamp);
    } else {
      onDateChange(0, 0); // or default values
    }
  };
  const todayPlusOne = new Date();
  todayPlusOne.setDate(todayPlusOne.getDate() + 1);

  return (
    <div style={{ display: "flex", marginLeft: SPACING.two }}>
      <DatePicker
        selectsRange
        placeholderText={overridePlaceholder || "Select Date Range"}
        dateFormat={"dd MMM yyyy"}
        startDate={dateRange[0]}
        endDate={dateRange[1]}
        maxDate={todayPlusOne}
        onChange={handleDateChange}
        isClearable
      />
    </div>
  );
}

export default DatetimePicker;
